import { Component, OnInit, Input } from '@angular/core';

import { cloneDeep } from 'lodash';

import { DynamicFormEventType, DynamicFormEvent } from '../../utils/dynamic-form-model';

@Component({
  selector: 'df-form-event-group',
  templateUrl: './form-event-group.component.html',
  styleUrls: ['./form-event-group.component.css']
})
export class FormEventGroupComponent implements OnInit {
  currentIndex: number;
  currentEvent: DynamicFormEvent;

  @Input()
  set events(events: Array<DynamicFormEvent>) {
    if (!events || events.length === 0) {
      this.formEvents = [
        { groupName: '', script: '', name: DynamicFormEventType.BeforeLoad, description: 'å è½½å' },
        { groupName: '', script: '', name: DynamicFormEventType.AfterLoad, description: 'å è½½å' },
        { groupName: '', script: '', name: DynamicFormEventType.BeforeDataLoad, description: 'æ°æ®å è½½å' },
        { groupName: '', script: '', name: DynamicFormEventType.AfterDataLoad, description: 'æ°æ®å è½½å' }
      ];
    } else {
      this.formEvents = events;
    }
  }

  get events(): Array<DynamicFormEvent> {
    return this.formEvents;
  }

  private formEvents: Array<DynamicFormEvent>;
  constructor() {}

  ngOnInit() {}

  getModels(): Array<DynamicFormEvent> {
    return this.formEvents;
  }

  // æ¾ç¤ºç¼è¾
  showEdit(i: number) {
    this.currentEvent = cloneDeep(this.formEvents[i]);
    this.currentIndex = i;
  }

  cancel() {
    this.clearEvent();
  }

  save() {
    this.update();
  }

  update() {
    this.formEvents[this.currentIndex] = cloneDeep(this.currentEvent);
    this.clearEvent();
  }

  /**
   * @description æ¸ç©ºevent
   *
   * @memberof FormEventGroupComponent
   */
  private clearEvent() {
    this.currentEvent = undefined;
    this.currentIndex = undefined;
  }
}
